(function () {
    'use strict';

    angular.module('app').directive('pkpAggregatedStatus', pkpAggregatedStatus);

    function pkpAggregatedStatus() {
        return {
            restrict: 'E',
            scope: {
                shipperUser: '=',
                isUserActive: '='
            },
            template: require('app/_directives/pkp-aggregated-status.directive.html'),
            controller: aggregatedStatusCtrl,
            controllerAs: 'agStatusCtrl'
        };

        function aggregatedStatusCtrl($scope) {
            var vm = this;

            vm.calcPercentage = calcPercentage;
            vm.shipperUser = $scope.shipperUser;
            vm.isUserActive = $scope.isUserActive;
        }

        function calcPercentage(states, currentState) {
            let sum = 0;
            let stateSum = 0;

            angular.forEach(states, function (value, state) {
                sum = sum + value;
                if (state == currentState) {
                    stateSum = value;
                }
            });
            return (stateSum * 100) / sum;
        }
    }
})();
